"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _api = require("@react-google-maps/api");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = _interopRequireDefault(require("./icons/1.svg"));
var _2 = _interopRequireDefault(require("./icons/2.svg"));
var _3 = _interopRequireDefault(require("./icons/3.svg"));
var _4 = _interopRequireDefault(require("./icons/4.svg"));
var _5 = _interopRequireDefault(require("./icons/5.svg"));
var _helpers = require("./helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var ICONS_BY_STARS = {
  1: _.default,
  2: _2.default,
  3: _3.default,
  4: _4.default,
  5: _5.default
};
var DEFAULT_SIZE = {
  width: 28,
  height: 42
};
var SCALED_SIZE = {
  width: 28 * 2,
  height: 42 * 2
};
var MarkerByStars = function MarkerByStars(_ref) {
  var active = _ref.active,
    position = _ref.position,
    stars = _ref.stars,
    onClick = _ref.onClick;
  return /*#__PURE__*/_react.default.createElement(_api.Marker, {
    animation: 2,
    icon: {
      url: (0, _helpers.svgToBase64)(ICONS_BY_STARS[stars]),
      scaledSize: active ? SCALED_SIZE : DEFAULT_SIZE
    },
    position: position,
    onClick: onClick
  });
};
MarkerByStars.propTypes = {
  position: _propTypes.default.exact({
    lat: _propTypes.default.number.isRequired,
    lng: _propTypes.default.number.isRequired
  }).isRequired,
  stars: _propTypes.default.number.isRequired,
  active: _propTypes.default.bool,
  onClick: _propTypes.default.func
};
MarkerByStars.defaultProps = {
  active: false
};
var _default = exports.default = (0, _react.memo)(MarkerByStars);